import logoBlack from '@images/ajuntament_logo_black.svg';
import logoWhite from '@images/ajuntament_logo_white.svg';

const LOGOS = { black: logoBlack, white: logoWhite };

// viewBox size shared by both logo SVGs; update it if the assets are replaced
// or the logo will render distorted.
const LOGO_ASPECT_RATIO = 3713 / 757;

export default function AjuntamentBrandBanner({ variant = 'black', width = 160, ...props }) {
    if (import.meta.env.DEV && !LOGOS[variant]) {
        console.warn(`AjuntamentBrandBanner: unknown variant "${variant}", falling back to "black".`);
    }

    return (
        <img
            src={LOGOS[variant] ?? LOGOS.black}
            alt="Ajuntament de Barcelona"
            width={width}
            height={Math.round(width / LOGO_ASPECT_RATIO)}
            {...props}
        />
    );
}
